import { GoogleOAuthProvider } from "@react-oauth/google";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useEffect } from "react";
import { CookiesProvider } from "react-cookie";
import ReactGA from "react-ga4";
import { useDispatch } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import { TooltipProvider } from "@/app/components/ui/tooltip";
import { AuthProvider } from "./app/context/Auth/AuthContext";
import { FitCheckBasketProvider } from "./app/context/FitCheckBasket";
import { useGoogleTokenRefresh } from "./app/hooks/useGoogleTokenRefresh";
import RouteHandler from "./app/router/RouteHandler";
import resume from "./app/seed/buildResume"; //we could use this to build a sample resume.

function GoogleTokenRefresh() {
	useGoogleTokenRefresh();
	return null;
}

const TRACKING_ID = "G-Y75YMD4HJM";
ReactGA.initialize(TRACKING_ID);

export const queryClient = new QueryClient();

function App({ children = null }) {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch({ type: "SAMPLE_DATA", payload: resume.getResume() });
	}, [dispatch]);

	return (
		<BrowserRouter>
			<CookiesProvider>
				<QueryClientProvider client={queryClient}>
					<AuthProvider>
						<FitCheckBasketProvider>
							<GoogleOAuthProvider clientId="509917624249-5ociqc44vp23feb7i78ifgq1g6aiupel.apps.googleusercontent.com">
								<TooltipProvider>
									<GoogleTokenRefresh />
									<RouteHandler />
									<Toaster position="top-right" richColors />
									{children}
								</TooltipProvider>
							</GoogleOAuthProvider>
						</FitCheckBasketProvider>
					</AuthProvider>
					<ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
				</QueryClientProvider>
			</CookiesProvider>
		</BrowserRouter>
	);
}

export default App;
